export const getContactsListFiltersParams = (
  unreadApplied,
  openApplied,
  selectedOrgIds
) => {
  return {
    ...(unreadApplied ? { unread: unreadApplied } : {}),
    ...(openApplied ? { active_window: openApplied } : {}),
    ...(selectedOrgIds?.length ? { org_ids: selectedOrgIds?.join(",") } : {}),
  };
};
